import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { joinClasses } from 'utils/utility';
import { useImagesContext } from 'contexts/ImagesContext';
import { clickAnime, calvh } from 'utils/element';
import { ButtonBase } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: ({ styles }) => ({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...(styles?.root || {}),
  }),
  'button-save': {
    height: ({ height }) => height || calvh('7vh'),
    maxWidth: '22vw',
    objectFit: 'contain',
  },
}));

const ButtonSave = (props) => {
  const { onClick, disabled } = props;
  const { images } = useImagesContext();
  const c = joinClasses(useStyles({ ...props }));

  return (
    <ButtonBase className={c('root')}>
      <img
        className={c('button-save')}
        src={images['button-save-btn.png']}
        ref={(ref) => !disabled && clickAnime(ref)}
        onClick={(e) => !disabled && onClick && onClick(e)}
      />
    </ButtonBase>
  );
};

export default ButtonSave;
